import { OrderItem, SuccesfullPartialPayment } from "@lemmonhq/types";
import { calculateOrderItemTotal } from "@lemmonhq/orders";

export const calculatePartialTotal = (
  items: OrderItem[],
  selectedItems: Record<number, number>,
): number => {
  return items.reduce((total, item) => {
    const selectedQuantity = selectedItems[item.id] || 0;
    return selectedQuantity === 0
      ? total
      : total + calculateOrderItemTotal(item, selectedQuantity);
  }, 0);
};

export const isItemFullyPaid = (
  item: OrderItem,
  partialPayments: SuccesfullPartialPayment[],
): boolean => {
  const paidQuantity = getPaidQuantity(item, partialPayments);
  return paidQuantity >= item.quantity;
};

export const getPaidQuantity = (
  item: OrderItem,
  partialPayments: SuccesfullPartialPayment[],
): number => {
  return partialPayments
    .filter((payment) => payment.order_item_id === item.id)
    .reduce((total, payment) => total + payment.quantity, 0);
};

export const getRemainingQuantity = (
  item: OrderItem,
  partialPayments: SuccesfullPartialPayment[],
): number => {
  const paidQuantity = getPaidQuantity(item, partialPayments);
  return Math.max(0, item.quantity - paidQuantity);
};
